/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Placeholder_2Inputs */

const en_try_magic_placeholder_2 = /** @type {(inputs: Try_Magic_Placeholder_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share your thoughts...`)
};

const es_try_magic_placeholder_2 = /** @type {(inputs: Try_Magic_Placeholder_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte tus pensamientos...`)
};

/**
* | output |
* | --- |
* | "Share your thoughts..." |
*
* @param {Try_Magic_Placeholder_2Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_placeholder_2 = /** @type {((inputs?: Try_Magic_Placeholder_2Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Placeholder_2Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_placeholder_2(inputs)
	return en_try_magic_placeholder_2(inputs)
});